import { useEffect, useState, useCallback } from 'react';
import { LicenseAssignment } from '../components/LicenseAssignment';
import { ForeignDnsRuns } from '../components/ForeignDnsRuns';
import { DomainContests } from '../components/DomainContests';
import { SequencerConnect } from '../components/SequencerConnect';
import { TeamLogin } from './TeamLogin';
import { TeamShell, type TeamTab } from './TeamShell';

type AuthState = 'unknown' | 'authed' | 'anon';

export function TeamApp(): JSX.Element | null {
  const [auth, setAuth] = useState<AuthState>('unknown');
  const [tab, setTab] = useState<TeamTab>('licensing');

  const refreshAuth = useCallback(async (): Promise<void> => {
    try {
      const r = await fetch('/api/team/me');
      setAuth(r.ok ? 'authed' : 'anon');
    } catch {
      setAuth('anon');
    }
  }, []);

  useEffect(() => {
    void refreshAuth();
  }, [refreshAuth]);

  if (auth === 'unknown') return null;

  if (auth === 'anon') {
    return <TeamLogin onLogin={() => setAuth('authed')} />;
  }

  return (
    <TeamShell onSignOut={() => setAuth('anon')} tab={tab} onTabChange={setTab}>
      {tab === 'licensing' && <LicenseAssignment />}
      {tab === 'foreign-dns' && <ForeignDnsRuns />}
      {tab === 'domain-contests' && <DomainContests />}
      {tab === 'sequencer' && <SequencerConnect />}
    </TeamShell>
  );
}
